import type { PropsWithChildren } from 'react';
import { ErrorBoundary, type FallbackProps } from 'react-error-boundary';
import { ErrorBoundaryFallback } from './ErrorBoundaryFallback';
export function GlobalErrorBoundary({
  children
}: PropsWithChildren) {
  return <ErrorBoundary FallbackComponent={Fallback} data-sentry-element="ErrorBoundary" data-sentry-component="GlobalErrorBoundary" data-sentry-source-file="GlobalErrorBoundary.tsx">{children}</ErrorBoundary>;
}
function Fallback({
  error
}: FallbackProps) {
  return <ErrorBoundaryFallback error={error} data-sentry-element="ErrorBoundaryFallback" data-sentry-component="Fallback" data-sentry-source-file="GlobalErrorBoundary.tsx" />;
}